export default __webpack_public_path__ + "static/media/logo_campaign_percent.0a05078b.png";